module.exports = __webpack_public_path__ + "static/media/lasalle-bristol-logo-color.03138a02.svg";